module.exports = __webpack_public_path__ + "img/plus.82b5f06b.svg";